module.exports = __webpack_public_path__ + "static/img/2_1_1.a04f6bf2.jpg";